// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FPyzb","left":"styles_left__2OCH5"};